import { PlacePagination } from '../model/place_pagination';
import { FetchPlaceRepository } from '../../data/repository/fetch_place_repository';
import { Pagination } from "@/core/domain/model/pagination";
import { DataOptions } from "vuetify";
import { en } from '../model/place';

export interface FetchPlaceUseCase {
    (pagination: DataOptions, search: string): Promise<PlacePagination>
}

const fetchPlaceUseCase = (repository: FetchPlaceRepository): FetchPlaceUseCase => async (pagination: DataOptions, search: string) => {
    try {
        const payload: Pagination = {
            sort: pagination.sortBy.map((s: string) => en[s]).join(','),
            descending: pagination.sortDesc.join(','),
            page: pagination.page,
            itemsPerPage: pagination.itemsPerPage,
            search: search
        }
        return await repository(payload);
    } catch (error) {
        throw error
    }
}

export default fetchPlaceUseCase;